'use client';

import { useStore } from '@/providers/app-store-provider';
import { isEmpty, isInZeloolApp } from '@/utils/tools';
import { useEffect } from 'react';
import InstadeskPop from './InstadeskPop';
import ShulexIframePop from './ShulexIframePop';
import { env } from '@/utils/env';
import { normalizeChatUrl, resolveCustomerService } from './customer-service-experiment';
import { useLulingChatExperiment } from './useLulingChatExperiment';
/**
 * 加载 Zendesk 脚本
 */
function loadZendesk() {
  const oScript = document.createElement('script');
  oScript.type = 'text/javascript';
  oScript.id = 'ze-snippet';
  oScript.async = !0;
  oScript.src = `https://static.zdassets.com/ekr/snippet.js?key=${env.NEXT_PUBLIC_ZENDESK_KEY}`;
  // app中不加载客服插件
  if (!isInZeloolApp()) {
    document.head.appendChild(oScript);
    // 客服插件加载完成后，再执行打招呼配置数据的获取，防止点击客服气泡无效
    oScript.onload = () => {
      return Promise.resolve();
    };
  }
}

/**
 * 客服弹窗组件
 *
 * 在 layout.tsx 中使用，统一管理全局客服弹窗
 * - 负责初始化客服配置（加载脚本等）
 * - 负责展示和隐藏弹窗
 * - 状态通过全局 store 管理
 */
export default function CustomerServicePopups() {
  const publicResourceData = useStore((state) => state.publicResourceData);
  const isMobile = useStore((state) => state.isMobileScreen);

  // 从全局 store 读取状态
  const customerService = useStore((state) => state.customerService);
  const setCustomerService = useStore((state) => state.setCustomerService);
  const chatConfig = publicResourceData?.jsonvalues?.instadesk_chat;
  const group = useLulingChatExperiment(Boolean(normalizeChatUrl(chatConfig?.luling_url)));
  const { deskType, instadeskUrl, shulexIframeUrl, iframeProvider } = resolveCustomerService(
    chatConfig,
    isMobile,
    group,
  );
  const hasZendeskPopup = !isEmpty(publicResourceData?.jsonvalues?.customer_service_popup);

  /**
   * 初始化客服配置
   */
  useEffect(() => {
    // 分组或配置晚到时，不打断已经开始的会话；关闭后再应用当前选择。
    if (customerService.showInstadesk || customerService.showShulexIframe) return;
    if (!chatConfig) return;
    setCustomerService({ deskType, instadeskUrl, shulexIframeUrl, iframeProvider });
    if (deskType === 'zendesk' && hasZendeskPopup && !document.getElementById('ze-snippet')) {
      loadZendesk();
    }
  }, [
    chatConfig,
    deskType,
    instadeskUrl,
    shulexIframeUrl,
    iframeProvider,
    hasZendeskPopup,
    customerService.showInstadesk,
    customerService.showShulexIframe,
    setCustomerService,
  ]);

  return (
    <>
      <InstadeskPop
        show={customerService.showInstadesk}
        instadeskUrl={customerService.instadeskUrl}
        onClose={() => setCustomerService({ showInstadesk: false })}
      />
      <ShulexIframePop
        show={customerService.showShulexIframe}
        iframeUrl={customerService.shulexIframeUrl}
        provider={customerService.iframeProvider}
        onClose={() => setCustomerService({ showShulexIframe: false })}
      />
    </>
  );
}
